import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Prices from '../views/Prices.vue'
import Faq from '../views/Faq.vue'
import Catalog from '../views/Catalog.vue'
import Reviews from '../views/Reviews.vue'
import Fortune from '../views/Fortune.vue'
import PlaceholderPage from '../views/PlaceholderPage.vue'
import Contacts from '../views/Contacts.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: 'Prestige Inside — картины с деньгами и смыслом' }
  },
  {
    path: '/prices',
    name: 'prices',
    component: Prices,
    meta: { title: 'Цены — Prestige Inside' }
  },
  {
    path: '/catalog',
    name: 'catalog',
    component: Catalog,
    meta: { title: 'Наши работы' }
  },
  {
    path: '/reviews',
    name: 'reviews',
    component: Reviews,
    meta: { title: 'Отзывы' }
  },
  {
    path: '/faq',
    name: 'faq',
    component: Faq,
    meta: { title: 'FAQ' }
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: Contacts,
    meta: { title: 'Контакты' }
  },
  {
    path: '/fortune',
    name: 'fortune',
    component: Fortune,
    meta: { title: 'Скидки для клиентов' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
    return { left: 0, top: 0 }
  }
})

const defaultTitle = 'Prestige Inside — картины с деньгами и смыслом'
router.afterEach((to) => {
  document.title = to.path === '/' ? defaultTitle : (to.meta.title ? to.meta.title + ' | Prestige Inside' : defaultTitle)
})

export default router
